import React from "react";

import FocusContext from "../map-management/focus-context";
import LoadingSpinner from "./loading-spinner";

export default class GloballyControlledLoadingSpinner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            reason: undefined,
        };
    }

    componentDidMount() {
        FocusContext.onLoadStatusChange.addListener(() => {
            const shouldBeLoading = this.getIdealLoadingState();
            if (!this.state.loading && !shouldBeLoading) {
                return;
            }
            if (shouldBeLoading) {
                const newKey = Object.keys(FocusContext._activeLoadHandlers)[0];
                this.setState({
                    loading: true,
                    reason: FocusContext._activeLoadHandlers[newKey],
                });
            } else {
                this.setState({
                    loading: false,
                    reason: "done",
                });
            }
        });
    }

    getIdealLoadingState() {
        return Object.keys(FocusContext._activeLoadHandlers).length > 0;
    }

    render() {
        // some kind of react internal race condition means this somehow ends up in the wrong
        // state and so we need to trigger a re-calc when that happens.
        if (this.state.loading !== this.getIdealLoadingState()) {
            FocusContext.onLoadStatusChange.trigger({});
        }
        return <LoadingSpinner loading={this.state.loading} reason={this.state.reason} />;
    }
}
